import { selectUserFavorites, updateFavorites } from 'containers/Login/loginSlice'
import { selectWarehouseStatus } from 'containers/Warehouses/warehousesSlice'
import { useDispatch, useSelector } from 'react-redux'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import useWarehouses from 'hooks/useWarehouses'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'
import Loading from 'components/Loading'
import { POST } from 'rest/request'
import * as urls from 'rest/urls'
import { useState } from 'react'
import '../style.scss'

const EditFavoritePopup = () => {
  const [isSending, setSending] = useState(false)
  const favorites = useSelector(selectUserFavorites)
  const [selectedValues, selectValues] = useState(favorites.map(f => f.related.id))
  const status = useSelector(selectWarehouseStatus)
  const warehouses = useWarehouses()

  const isLoading = status !== 'succeed'

  const dispatch = useDispatch()
  const { goBack } = useHistory()
  const { t } = useTranslation('dashboard')
  const updateFavorite = async () => {
    if (isSending) return
    setSending(true)
    try {
      const response = await POST(urls.favorites, { body: { warehouseIds: selectedValues } })
      if (response.success && response.data) {
        dispatch(updateFavorites(response.data))
        goBack()
      } else {
        throw new Error()
      }
    } catch (error) {
      setSending(false)
    }
  }

  return (
    <Popup>
      <div className='popup__title'>
        <div>{t('favorites')}</div>
        <div>{t('selectTheServicesYouWantToSeeOnTheDashboard')}</div>
      </div>

      <div className='popup__favorite'>
        {isLoading && warehouses.length === 0
          ? <Loading />
          : warehouses.map(({ objectId, typeName, name, placeAddress }) => {
            const isChecked = selectedValues.includes(objectId)
            return <div
              key={objectId}
              className={`favorite__item${isChecked ? ' --checked' : ''}`}
              onClick={() => {
                if (isSending) return
                selectValues(
                  isChecked
                    ? selectedValues.filter(f => f !== objectId)
                    : [...selectedValues, objectId]
                )
              }}>
              <div className='favorite__item__left'>
                <h2>{typeName} {t('number')}{name}</h2>
                <span>{placeAddress}</span>
              </div>
              <div className='favorite__item__right'>
                <i className='icon icon--heart'></i>
              </div>
            </div>
          })}
      </div>

      <ArrowBtn
        enlarged
        showArrow={false}
        disabled={isSending}
        text={t(isSending ? 'saving' : 'save')}
        action={updateFavorite} />
    </Popup>
  )
}

export default EditFavoritePopup